import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vModelText as _vModelText, withKeys as _withKeys, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "grid min-h-0 flex-1 grid-cols-1 gap-6 lg:grid-cols-12"
};
const _hoisted_2 = {
  class: "lg:col-span-3"
};
const _hoisted_3 = {
  class: "rounded-2xl border border-slate-200 bg-white p-5 shadow-sm"
};
const _hoisted_4 = {
  class: "flex items-center justify-between"
};
const _hoisted_5 = {
  key: 0,
  class: "mt-4 space-y-3"
};
const _hoisted_6 = {
  key: 1,
  class: "mt-4 space-y-3"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  class: "flex items-center gap-3"
};
const _hoisted_9 = {
  class: "flex h-10 w-10 items-center justify-center rounded-lg bg-white"
};
const _hoisted_10 = {
  class: "text-sm font-medium text-slate-900"
};
const _hoisted_11 = {
  class: "mt-1 flex items-center gap-2 text-xs text-slate-500"
};
const _hoisted_12 = {
  class: "flex items-center gap-2"
};
const _hoisted_13 = ["onClick"];
const _hoisted_14 = ["onClick"];
const _hoisted_15 = {
  key: 0,
  class: "rounded-xl border border-dashed border-slate-200 p-6 text-center text-sm text-slate-500"
};
const _hoisted_16 = {
  class: "flex min-h-0 flex-col lg:col-span-9"
};
const _hoisted_17 = {
  class: "list-page-table-panel list-page-table-panel--fill"
};
const _hoisted_18 = {
  class: "border-b border-slate-200 p-5"
};
const _hoisted_19 = {
  class: "filter-bar-field is-wide relative"
};
const _hoisted_20 = ["disabled"];
const _hoisted_21 = ["disabled"];
const _hoisted_22 = {
  class: "flex items-center gap-2"
};
const _hoisted_23 = {
  class: "font-medium"
};
const _hoisted_24 = {
  class: "data-table-inline-tag"
};
const _hoisted_25 = {
  class: "data-table-inline-tag"
};
const _hoisted_26 = {
  class: "text-slate-600"
};
const _hoisted_27 = {
  class: "text-slate-600 text-xs"
};
const _hoisted_28 = {
  class: "flex items-center justify-center gap-1"
};
const _hoisted_29 = ["onClick"];
const _hoisted_30 = ["onClick"];
const _hoisted_31 = ["onClick"];
const _hoisted_32 = ["onClick"];
const _hoisted_33 = ["onClick"];
const _hoisted_34 = ["onClick"];
const _hoisted_35 = {
  class: "flex items-center justify-between border-b border-slate-200 px-6 py-4"
};
const _hoisted_36 = {
  class: "text-lg font-semibold text-slate-900"
};
const _hoisted_37 = {
  class: "px-6 py-5"
};
const _hoisted_38 = {
  class: "space-y-4"
};
const _hoisted_39 = ["disabled"];
const _hoisted_40 = {
  class: "px-6 py-5 text-sm text-slate-600"
};
const _hoisted_41 = {
  class: "flex items-center justify-between border-b border-slate-200 px-6 py-4"
};
const _hoisted_42 = {
  class: "px-6 py-5"
};
const _hoisted_43 = {
  class: "space-y-4"
};
const _hoisted_44 = ["value"];
const _hoisted_45 = {
  class: "grid grid-cols-2 gap-3"
};
const _hoisted_46 = {
  class: "flex justify-end gap-2 border-t border-slate-200 px-6 py-4"
};
const _hoisted_47 = ["disabled"];
import { ref, reactive, computed, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { ElMessage, ElMessageBox } from 'element-plus';
import { formatDateTimeText } from '@/utils/dateFormat';
import { exportWorkflowStats } from '@/api/flow';
import { downloadBlob, resolveBlobErrorMessage } from '@/utils/download';
import { validateStatsExportRange } from '@/utils/workflowStatsConfig';
import AppModal from '@/components/AppModal.vue';
import { Plus, Edit, Close, Delete, Connection, Folder } from '@element-plus/icons-vue';
import { getTemplatePage, deleteTemplate, updateTemplateStatus, getWorkflowCategories, createWorkflowCategory, updateWorkflowCategory, deleteWorkflowCategory } from '@/api';
import AppPagination from '@/components/AppPagination.vue';
import ListPageShell from '@/components/ListPageShell.vue';
import PageFilterBar from '@/components/PageFilterBar.vue';
export default {
  __name: 'WorkflowList',
  setup(__props) {
    const router = useRouter();

    // 查询参数
    const queryParams = reactive({
      templateName: '',
      status: '',
      categoryCode: '',
      pageNum: 1,
      pageSize: 10
    });

    // 表格数据
    const tableData = ref([]);
    const loading = ref(false);
    const total = ref(0);
    const totalPages = computed(() => Math.ceil(total.value / queryParams.pageSize) || 1);

    // 分类列表
    const categories = ref([]);
    const categoryLoading = ref(false);
    const selectedCategory = ref('');

    // 分类弹窗
    const showCategoryModal = ref(false);
    const isCategoryEdit = ref(false);
    const categoryForm = reactive({
      id: null,
      categoryCode: '',
      categoryName: '',
      sort: 1,
      description: ''
    });

    // 删除确认弹窗
    const showDeleteModal = ref(false);
    const deleteConfirmMessage = ref('');
    const deletePayload = ref({
      type: '',
      id: null
    });
    function statusLabel(status) {
      const labels = {
        0: '已停用',
        1: '已启用'
      };
      return labels[status] || status;
    }
    function workflowStatusClass(status) {
      const classes = {
        0: 'status-badge is-rose',
        1: 'status-badge is-success'
      };
      return classes[status] || 'status-badge is-neutral';
    }
    function getStatusColor(status) {
      const colors = {
        0: '#f56c6c',
        1: '#67c23a'
      };
      return colors[status] || '#909399';
    }

    // 查询
    async function handleQuery() {
      queryParams.pageNum = 1;
      await fetchData();
    }

    // 重置
    function resetQuery() {
      queryParams.templateName = '';
      queryParams.status = '';
      queryParams.categoryCode = selectedCategory.value || '';
      queryParams.pageNum = 1;
      fetchData();
    }
    function handleRefresh() {
      fetchData();
    }

    // 获取数据
    async function fetchData() {
      loading.value = true;
      try {
        const data = await getTemplatePage(queryParams);
        tableData.value = data.records || [];
        total.value = data.total || 0;
      } catch (error) {
        console.error('获取流程列表失败:', error);
        ElMessage.error(error.message || '获取流程列表失败');
      } finally {
        loading.value = false;
      }
    }

    // 获取分类列表
    async function fetchCategories() {
      categoryLoading.value = true;
      try {
        const data = await getWorkflowCategories();
        categories.value = data || [];
      } catch (error) {
        console.error('获取分类列表失败:', error);
        ElMessage.error(error.message || '获取分类列表失败');
      } finally {
        categoryLoading.value = false;
      }
    }

    // 应用分类筛选
    async function applyCategoryFilter(categoryId) {
      const nextValue = String(categoryId);
      selectedCategory.value = selectedCategory.value === nextValue ? '' : nextValue;
      queryParams.categoryCode = selectedCategory.value;
      await fetchData();
    }

    // 打开分类弹窗
    function openCategoryModal(category) {
      if (category) {
        Object.assign(categoryForm, {
          id: category.id,
          categoryCode: category.categoryCode,
          categoryName: category.categoryName,
          sort: category.sort || 1,
          description: category.description || ''
        });
        isCategoryEdit.value = true;
      } else {
        Object.assign(categoryForm, {
          id: null,
          categoryCode: '',
          categoryName: '',
          sort: categories.value.length + 1,
          description: ''
        });
        isCategoryEdit.value = false;
      }
      showCategoryModal.value = true;
    }

    // 关闭分类弹窗
    function closeCategoryModal() {
      showCategoryModal.value = false;
    }

    // 提交分类
    async function submitCategory() {
      if (!categoryForm.categoryCode || !categoryForm.categoryName) {
        ElMessage.warning('请填写分类编码和名称');
        return;
      }
      try {
        if (isCategoryEdit.value) {
          await updateWorkflowCategory({
            categoryId: categoryForm.id,
            categoryName: categoryForm.categoryName,
            sort: categoryForm.sort,
            description: categoryForm.description
          });
          ElMessage.success('分类更新成功');
        } else {
          await createWorkflowCategory({
            categoryCode: categoryForm.categoryCode,
            categoryName: categoryForm.categoryName,
            sort: categoryForm.sort,
            description: categoryForm.description
          });
          ElMessage.success('分类创建成功');
        }
        showCategoryModal.value = false;
        await fetchCategories();
      } catch (error) {
        ElMessage.error(error.message || '保存分类失败');
      }
    }

    // 确认删除分类
    function confirmDeleteCategory(category) {
      deletePayload.value = {
        type: 'category',
        id: category.id
      };
      deleteConfirmMessage.value = `确认删除分类「${category.categoryName}」？若分类下存在流程将无法删除。`;
      showDeleteModal.value = true;
    }

    // 关闭删除确认弹窗
    function closeDeleteModal() {
      showDeleteModal.value = false;
    }

    // 确认删除操作
    async function confirmDeleteAction() {
      const {
        type,
        id
      } = deletePayload.value;
      try {
        if (type === 'category') {
          await deleteWorkflowCategory({
            categoryId: id
          });
          ElMessage.success('分类已删除');
          // 如果删除的是当前筛选的分类，清除筛选
          if (selectedCategory.value === String(id)) {
            selectedCategory.value = '';
            queryParams.categoryCode = '';
          }
          await fetchCategories();
        }
      } catch (error) {
        ElMessage.error(error.message || '删除失败');
      } finally {
        showDeleteModal.value = false;
      }
    }

    // 分页
    function handlePageChange(page) {
      queryParams.pageNum = page;
      fetchData();
    }
    function handlePageSizeChange(size) {
      queryParams.pageSize = size;
      queryParams.pageNum = 1;
      fetchData();
    }

    // 新建流程
    function createWorkflow() {
      router.push({
        name: 'WorkflowDesigner'
      });
    }

    // 查看流程详情
    function viewWorkflow(row) {
      router.push({
        name: 'WorkflowDesigner',
        query: {
          id: row.id,
          mode: 'view'
        }
      });
    }

    // 编辑流程
    function editWorkflow(row) {
      router.push({
        name: 'WorkflowDesigner',
        query: {
          id: row.id
        }
      });
    }

    // 发布流程（更新状态为启用）
    async function handlePublish(row) {
      try {
        await ElMessageBox.confirm(`确定要启用流程"${row.templateName}"吗？启用后用户即可使用该流程。`, '启用确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
        await updateTemplateStatus({
          templateId: row.id,
          status: 1
        });
        ElMessage.success('启用成功');
        fetchData();
      } catch (error) {
        if (error !== 'cancel') {
          console.error('启用失败:', error);
          ElMessage.error(error.message || '启用失败');
        }
      }
    }

    // 停用流程（更新状态为停用）
    async function handleDisable(row) {
      try {
        await ElMessageBox.confirm(`确定要停用流程"${row.templateName}"吗？停用后用户将无法发起该流程。`, '停用确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
        await updateTemplateStatus({
          templateId: row.id,
          status: 0
        });
        ElMessage.success('停用成功');
        fetchData();
      } catch (error) {
        if (error !== 'cancel') {
          console.error('停用失败:', error);
          ElMessage.error(error.message || '停用失败');
        }
      }
    }

    // 删除流程
    async function handleDelete(row) {
      try {
        await ElMessageBox.confirm(`确定要删除流程"${row.templateName}"吗？删除后无法恢复。`, '删除警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'error'
        });
        await deleteTemplate({
          templateId: row.id
        });
        ElMessage.success('删除成功');
        fetchData();
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除失败:', error);
          ElMessage.error(error.message || '删除失败');
        }
      }
    }

    // 统计导出（spec §5.4 流程列表入口）：按钮显隐已按行 statsExportable + 权限过滤，弹窗只选时间区间
    const showStatsExportModal = ref(false);
    const statsExporting = ref(false);
    const statsExportTemplate = ref(null);
    const statsExportForm = reactive({
      startDate: '',
      endDate: ''
    });
    function openStatsExportModal(row) {
      statsExportTemplate.value = row;
      statsExportForm.startDate = '';
      statsExportForm.endDate = '';
      showStatsExportModal.value = true;
    }
    function closeStatsExportModal() {
      if (statsExporting.value) return;
      showStatsExportModal.value = false;
    }
    async function handleStatsExport() {
      if (statsExporting.value || !statsExportTemplate.value) return;
      const rangeError = validateStatsExportRange(statsExportForm.startDate, statsExportForm.endDate);
      if (rangeError) {
        ElMessage.warning(rangeError);
        return;
      }
      statsExporting.value = true;
      try {
        const {
          blob,
          fileName
        } = await exportWorkflowStats({
          templateCode: statsExportTemplate.value.templateCode,
          startDate: statsExportForm.startDate,
          endDate: statsExportForm.endDate
        });
        downloadBlob(blob, fileName);
        ElMessage.success('导出成功');
        showStatsExportModal.value = false;
      } catch (error) {
        ElMessage.error(await resolveBlobErrorMessage(error));
      } finally {
        statsExporting.value = false;
      }
    }

    // 初始化
    onMounted(async () => {
      await Promise.all([fetchData(), fetchCategories()]);
    });
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _directive_permission = _resolveDirective("permission");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createBlock(ListPageShell, {
        fill: ""
      }, {
        header: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createElementVNode("div", {
          class: "list-page-panel is-header-minimal"
        }, [_createElementVNode("div", {
          class: "list-page-heading"
        }, [_createElementVNode("div", {
          class: "list-page-heading-main"
        }, [_createElementVNode("h1", {
          class: "list-page-title"
        }, "流程管理"), _createElementVNode("p", {
          class: "list-page-description"
        }, "流程设计、发布与管理。")])])], -1)]))]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_cache[11] || (_cache[11] = _createElementVNode("h2", {
          class: "text-base font-semibold text-slate-900"
        }, "流程分类管理", -1)), _withDirectives((_openBlock(), _createElementBlock("button", {
          onClick: _cache[0] || (_cache[0] = $event => openCategoryModal()),
          class: "rounded-lg border border-slate-200 px-3 py-1.5 text-xs text-slate-700 hover:bg-slate-50"
        }, [...(_cache[10] || (_cache[10] = [_createTextVNode(" 新增分类 ", -1)]))])), [[_directive_permission, 'workflow:category:add']])]), _cache[12] || (_cache[12] = _createElementVNode("p", {
          class: "mt-2 text-xs text-slate-500"
        }, "删除前会校验，分类下存在流程将无法删除。", -1)), categoryLoading.value ? (_openBlock(), _createElementBlock("div", _hoisted_5, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, n => {
          return _createElementVNode("div", {
            key: n,
            class: "h-16 rounded-xl border border-slate-200 bg-slate-50"
          });
        }), 64))])) : (_openBlock(), _createElementBlock("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value, category => {
          return _openBlock(), _createElementBlock("div", {
            key: category.id,
            onClick: $event => applyCategoryFilter(category.id),
            class: _normalizeClass(['flex cursor-pointer items-center justify-between rounded-xl border p-4 transition', selectedCategory.value && Number(selectedCategory.value) === category.id ? 'border-primary-300 bg-primary-50/70 ring-1 ring-primary-200' : 'border-slate-200 bg-slate-50/70 hover:bg-slate-50'])
          }, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createVNode(_component_el_icon, {
            size: 20,
            class: "text-primary-600"
          }, {
            default: _withCtx(() => [_createVNode(_unref(Folder))]),
            _: 1
          })]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_10, _toDisplayString(category.categoryName), 1), _createElementVNode("div", _hoisted_11, [_createElementVNode("span", null, _toDisplayString(category.categoryCode), 1)])])]), _createElementVNode("div", _hoisted_12, [_withDirectives((_openBlock(), _createElementBlock("button", {
            onClick: _withModifiers($event => openCategoryModal(category), ["stop"]),
            class: "p-1.5 text-slate-400 hover:text-primary-600 transition-colors",
            title: "编辑"
          }, [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_unref(Edit))]),
            _: 1
          })], 8, _hoisted_13)), [[_directive_permission, 'workflow:category:edit']]), _withDirectives((_openBlock(), _createElementBlock("button", {
            onClick: _withModifiers($event => confirmDeleteCategory(category), ["stop"]),
            class: "p-1.5 text-slate-400 hover:text-red-600 transition-colors",
            title: "删除"
          }, [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_unref(Delete))]),
            _: 1
          })], 8, _hoisted_14)), [[_directive_permission, 'workflow:category:delete']])])], 10, _hoisted_7);
        }), 128)), !categories.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_15, " 暂无分类数据 ")) : _createCommentVNode("", true)]))])]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_cache[15] || (_cache[15] = _createElementVNode("div", {
          class: "flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between"
        }, [_createElementVNode("div", null, [_createElementVNode("h2", {
          class: "text-base font-semibold text-slate-900"
        }, "流程列表"), _createElementVNode("p", {
          class: "mt-1 text-xs text-slate-500"
        }, "点击流程名称可查看流程图与节点配置。")])], -1)), _createVNode(PageFilterBar, {
          "shell-class": "filter-bar-shell is-embedded",
          "body-class": "filter-bar-body is-embedded",
          "show-refresh": true,
          "refresh-loading": loading.value,
          onRefresh: handleRefresh
        }, {
          searchActionsLeading: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("button", {
            onClick: createWorkflow,
            class: "btn-primary"
          }, [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_unref(Plus))]),
            _: 1
          }), _cache[14] || (_cache[14] = _createTextVNode(" 新建流程 ", -1))])), [[_directive_permission, 'workflow:template:add']])]),
          searchActions: _withCtx(() => [_createElementVNode("button", {
            type: "button",
            class: "btn-primary",
            disabled: loading.value,
            onClick: handleQuery
          }, " 搜索 ", 8, _hoisted_20), _createElementVNode("button", {
            type: "button",
            class: "btn-secondary",
            disabled: loading.value,
            onClick: resetQuery
          }, " 重置 ", 8, _hoisted_21)]),
          default: _withCtx(() => [_createElementVNode("div", _hoisted_19, [_withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => queryParams.templateName = $event),
            type: "text",
            placeholder: "搜索流程名称",
            class: "form-search-input form-control-sm w-full",
            onKeyup: _withKeys(handleQuery, ["enter"])
          }, null, 544), [[_vModelText, queryParams.templateName]]), _cache[13] || (_cache[13] = _createElementVNode("svg", {
            class: "absolute left-3 top-2.5 h-4 w-4 text-slate-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
          })], -1))]), _createVNode(_component_el_select, {
            modelValue: queryParams.status,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => queryParams.status = $event),
            placeholder: "请选择状态",
            class: "form-select form-control-sm filter-bar-field"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "全部状态",
              value: ""
            }), _createVNode(_component_el_option, {
              label: "已启用",
              value: 1
            }), _createVNode(_component_el_option, {
              label: "已停用",
              value: 0
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }, 8, ["refresh-loading"])]), _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          class: "app-table w-full",
          data: tableData.value,
          height: "100%"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            prop: "templateName",
            label: "流程名称",
            "min-width": "200"
          }, {
            default: _withCtx(({
              row
            }) => [_createElementVNode("div", _hoisted_22, [_createVNode(_component_el_icon, {
              size: 16,
              color: getStatusColor(row.status)
            }, {
              default: _withCtx(() => [_createVNode(_unref(Connection))]),
              _: 1
            }, 8, ["color"]), _createElementVNode("span", _hoisted_23, _toDisplayString(row.templateName), 1)])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "categoryCode",
            label: "分类",
            width: "120",
            align: "center"
          }, {
            default: _withCtx(({
              row
            }) => [_createElementVNode("span", _hoisted_24, _toDisplayString(row.categoryCode || '未分类'), 1)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "status",
            label: "状态",
            width: "100",
            align: "center"
          }, {
            default: _withCtx(({
              row
            }) => [_createElementVNode("span", {
              class: _normalizeClass(['status-badge', workflowStatusClass(row.status)])
            }, _toDisplayString(statusLabel(row.status)), 3)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "version",
            label: "版本",
            width: "80",
            align: "center"
          }, {
            default: _withCtx(({
              row
            }) => [_createElementVNode("span", _hoisted_25, "v" + _toDisplayString(row.version), 1)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "nodeCount",
            label: "节点数",
            width: "90",
            align: "center"
          }, {
            default: _withCtx(({
              row
            }) => [_createElementVNode("span", _hoisted_26, _toDisplayString(row.nodeCount || 0), 1)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "description",
            label: "描述",
            "min-width": "200",
            "show-overflow-tooltip": ""
          }), _createVNode(_component_el_table_column, {
            prop: "createTime",
            label: "创建时间",
            width: "160",
            align: "center"
          }, {
            default: _withCtx(({
              row
            }) => [_createElementVNode("span", _hoisted_27, _toDisplayString(_unref(formatDateTimeText)(row.createTime)), 1)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "操作",
            width: "200",
            align: "center",
            fixed: "right"
          }, {
            default: _withCtx(({
              row
            }) => [_createElementVNode("div", _hoisted_28, [_createElementVNode("button", {
              onClick: $event => viewWorkflow(row),
              class: "table-action-button is-primary",
              title: "查看详情",
              "aria-label": "查看详情"
            }, [...(_cache[16] || (_cache[16] = [_createElementVNode("svg", {
              class: "w-4 h-4",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
            }), _createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
            })], -1)]))], 8, _hoisted_29), _withDirectives((_openBlock(), _createElementBlock("button", {
              onClick: $event => editWorkflow(row),
              class: "table-action-button is-primary",
              title: "编辑",
              "aria-label": "编辑"
            }, [...(_cache[17] || (_cache[17] = [_createElementVNode("svg", {
              class: "w-4 h-4",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
            })], -1)]))], 8, _hoisted_30)), [[_directive_permission, 'workflow:template:edit']]), row.statsExportable === true ? _withDirectives((_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: $event => openStatsExportModal(row),
              class: "table-action-button is-teal",
              title: "统计导出",
              "aria-label": "统计导出"
            }, [...(_cache[18] || (_cache[18] = [_createElementVNode("svg", {
              class: "w-4 h-4",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M9 17v-6m4 6V7m4 10v-3m5 4H4"
            })], -1)]))], 8, _hoisted_31)), [[_directive_permission, 'workflow:stats:export']]) : _createCommentVNode("", true), row.status === 0 ? _withDirectives((_openBlock(), _createElementBlock("button", {
              key: 1,
              onClick: $event => handlePublish(row),
              class: "table-action-button is-success",
              title: "启用",
              "aria-label": "启用"
            }, [...(_cache[19] || (_cache[19] = [_createElementVNode("svg", {
              class: "w-4 h-4",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
            })], -1)]))], 8, _hoisted_32)), [[_directive_permission, 'workflow:template:edit']]) : _createCommentVNode("", true), row.status === 1 ? _withDirectives((_openBlock(), _createElementBlock("button", {
              key: 2,
              onClick: $event => handleDisable(row),
              class: "table-action-button is-neutral",
              title: "停用",
              "aria-label": "停用"
            }, [...(_cache[20] || (_cache[20] = [_createElementVNode("svg", {
              class: "w-4 h-4",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M10 9v6m4-6v6m7-3a9 9 0 11-18 0 9 9 0 0118 0z"
            })], -1)]))], 8, _hoisted_33)), [[_directive_permission, 'workflow:template:edit']]) : _createCommentVNode("", true), _withDirectives((_openBlock(), _createElementBlock("button", {
              onClick: $event => handleDelete(row),
              class: "table-action-button is-danger",
              title: "删除",
              "aria-label": "删除"
            }, [...(_cache[21] || (_cache[21] = [_createElementVNode("svg", {
              class: "w-4 h-4",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
            })], -1)]))], 8, _hoisted_34)), [[_directive_permission, 'workflow:template:delete']])])]),
            _: 1
          })]),
          _: 1
        }, 8, ["data"])), [[_directive_loading, loading.value]]), total.value > 0 ? (_openBlock(), _createBlock(AppPagination, {
          key: 0,
          class: "pagination-bridge",
          current: queryParams.pageNum,
          size: queryParams.pageSize,
          total: total.value,
          pages: totalPages.value,
          "page-sizes": [10, 20, 50, 100],
          onPageChange: handlePageChange,
          onSizeChange: handlePageSizeChange
        }, null, 8, ["current", "size", "total", "pages"])) : _createCommentVNode("", true)])])]), _createVNode(AppModal, {
          visible: showCategoryModal.value,
          size: "md",
          onClose: closeCategoryModal
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_35, [_createElementVNode("h3", _hoisted_36, _toDisplayString(isCategoryEdit.value ? '编辑流程分类' : '新增流程分类'), 1), _createElementVNode("button", {
            onClick: closeCategoryModal,
            class: "rounded-full p-1 text-slate-400 hover:text-slate-600"
          }, [_createVNode(_component_el_icon, {
            size: 20
          }, {
            default: _withCtx(() => [_createVNode(_unref(Close))]),
            _: 1
          })])]), _createElementVNode("div", _hoisted_37, [_createElementVNode("div", _hoisted_38, [_createElementVNode("div", null, [_cache[22] || (_cache[22] = _createElementVNode("label", {
            class: "text-sm font-medium text-slate-700"
          }, [_createTextVNode("分类编码 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => categoryForm.categoryCode = $event),
            disabled: isCategoryEdit.value,
            class: "form-input mt-2 w-full",
            placeholder: "例如 WORKFLOW_ABSENCE"
          }, null, 8, _hoisted_39), [[_vModelText, categoryForm.categoryCode]])]), _createElementVNode("div", null, [_cache[23] || (_cache[23] = _createElementVNode("label", {
            class: "text-sm font-medium text-slate-700"
          }, [_createTextVNode("分类名称 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => categoryForm.categoryName = $event),
            class: "form-input mt-2 w-full",
            placeholder: "例如 请假流程"
          }, null, 512), [[_vModelText, categoryForm.categoryName]])]), _createElementVNode("div", null, [_cache[24] || (_cache[24] = _createElementVNode("label", {
            class: "text-sm font-medium text-slate-700"
          }, "排序", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => categoryForm.sort = $event),
            type: "number",
            class: "form-input mt-2 w-full"
          }, null, 512), [[_vModelText, categoryForm.sort, void 0, {
            number: true
          }]])]), _createElementVNode("div", null, [_cache[25] || (_cache[25] = _createElementVNode("label", {
            class: "text-sm font-medium text-slate-700"
          }, "描述", -1)), _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => categoryForm.description = $event),
            rows: "3",
            class: "form-textarea mt-2",
            placeholder: "分类说明"
          }, null, 512), [[_vModelText, categoryForm.description]])])])]), _createElementVNode("div", {
            class: "flex justify-end gap-2 border-t border-slate-200 px-6 py-4"
          }, [_createElementVNode("button", {
            onClick: closeCategoryModal,
            class: "rounded-lg border border-slate-200 px-4 py-2 text-sm text-slate-700"
          }, "取消"), _createElementVNode("button", {
            onClick: submitCategory,
            class: "rounded-lg bg-primary-700 px-4 py-2 text-sm text-white hover:bg-primary-800"
          }, "保存")])]),
          _: 1
        }, 8, ["visible"]), _createVNode(AppModal, {
          visible: showDeleteModal.value,
          size: "md",
          onClose: closeDeleteModal
        }, {
          default: _withCtx(() => [_cache[26] || (_cache[26] = _createElementVNode("div", {
            class: "border-b border-slate-200 px-6 py-4"
          }, [_createElementVNode("h3", {
            class: "text-lg font-semibold text-slate-900"
          }, "确认删除")], -1)), _createElementVNode("div", _hoisted_40, _toDisplayString(deleteConfirmMessage.value), 1), _createElementVNode("div", {
            class: "flex justify-end gap-2 border-t border-slate-200 px-6 py-4"
          }, [_createElementVNode("button", {
            onClick: closeDeleteModal,
            class: "rounded-lg border border-slate-200 px-4 py-2 text-sm text-slate-700"
          }, "取消"), _createElementVNode("button", {
            onClick: confirmDeleteAction,
            class: "rounded-lg bg-red-500 px-4 py-2 text-sm text-white hover:bg-red-600"
          }, "删除")])]),
          _: 1
        }, 8, ["visible"]), _createVNode(AppModal, {
          visible: showStatsExportModal.value,
          size: "md",
          onClose: closeStatsExportModal
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_41, [_cache[27] || (_cache[27] = _createElementVNode("h3", {
            class: "text-lg font-semibold text-slate-900"
          }, "统计导出", -1)), _createElementVNode("button", {
            onClick: closeStatsExportModal,
            class: "rounded-full p-1 text-slate-400 hover:text-slate-600",
            "aria-label": "关闭"
          }, [_createVNode(_component_el_icon, {
            size: 20
          }, {
            default: _withCtx(() => [_createVNode(_unref(Close))]),
            _: 1
          })])]), _createElementVNode("div", _hoisted_42, [_createElementVNode("div", _hoisted_43, [_createElementVNode("div", null, [_cache[28] || (_cache[28] = _createElementVNode("label", {
            class: "text-sm font-medium text-slate-700"
          }, "流程模板", -1)), _createElementVNode("input", {
            value: statsExportTemplate.value?.templateName || '',
            class: "form-input form-readonly mt-2 w-full",
            readonly: ""
          }, null, 8, _hoisted_44)]), _createElementVNode("div", _hoisted_45, [_createElementVNode("div", null, [_cache[29] || (_cache[29] = _createElementVNode("label", {
            class: "text-sm font-medium text-slate-700"
          }, [_createTextVNode("开始日期 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _createVNode(_component_el_date_picker, {
            modelValue: statsExportForm.startDate,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => statsExportForm.startDate = $event),
            type: "date",
            class: "form-date mt-2 w-full",
            "value-format": "YYYY-MM-DD",
            placeholder: "请选择开始日期"
          }, null, 8, ["modelValue"])]), _createElementVNode("div", null, [_cache[30] || (_cache[30] = _createElementVNode("label", {
            class: "text-sm font-medium text-slate-700"
          }, [_createTextVNode("结束日期 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _createVNode(_component_el_date_picker, {
            modelValue: statsExportForm.endDate,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => statsExportForm.endDate = $event),
            type: "date",
            class: "form-date mt-2 w-full",
            "value-format": "YYYY-MM-DD",
            placeholder: "请选择结束日期"
          }, null, 8, ["modelValue"])])]), _cache[31] || (_cache[31] = _createElementVNode("p", {
            class: "text-xs text-amber-600"
          }, "提示：dept 维度仅覆盖部署日之后提交的数据；仅统计审批通过的单据，时间跨度最长 12 个月。", -1))])]), _createElementVNode("div", _hoisted_46, [_createElementVNode("button", {
            onClick: closeStatsExportModal,
            class: "rounded-lg border border-slate-200 px-4 py-2 text-sm text-slate-700"
          }, "取消"), _withDirectives((_openBlock(), _createElementBlock("button", {
            onClick: handleStatsExport,
            disabled: statsExporting.value,
            class: "rounded-lg bg-primary-700 px-4 py-2 text-sm text-white hover:bg-primary-800 disabled:opacity-60"
          }, [_createTextVNode(_toDisplayString(statsExporting.value ? '导出中...' : '导出'), 1)], 8, _hoisted_47)), [[_directive_permission, 'workflow:stats:export']])])]),
          _: 1
        }, 8, ["visible"])]),
        _: 1
      });
    };
  }
};